import React from 'react';
import LinkButton from './LinkButton';

export default function ContactSection() {
  return (
    <section id="get-in-touch" className="flex flex-col items-center justify-center p-8 w-full">
      <div className="flex flex-col gap-4 items-start max-w-[1024px] w-full">
        <p className="font-trispace type-section-label text-black">Get in touch</p>

        <h2 className="font-trispace type-h1 text-black">
          You've got here. Let's get you where you want to.
        </h2>

        <p className="font-trispace type-h3 text-black">
          Have a project in mind, or just curious what's possible? We're a direct conversation —
          no lengthy intake forms, no sales pipeline. Just good work.
        </p>

        {/* Contact options — 3-col on large, stacked + reversed on small */}
        <div className="flex flex-col lg:grid lg:grid-cols-3 gap-8 w-full mt-4">
          {/* Abbie — col 1 on large, bottom on mobile */}
          <div className="flex flex-col gap-4 items-start font-trispace text-black self-center">
            <p className="type-h3"><LinkButton onClick={void(0)}>@Abbie</LinkButton></p>
            <p className="type-body2">
              Let Abbie, our assistant, to take over. Need practical things? Like book a meeting,
              understand more about our work? Abbie can help you instantly.
            </p>
          </div>

          {/* Graphic — col 2 on large, top on mobile */}
          <div
            className="aspect-square w-full order-3 max-w-[100px] lg:order-[initial] lg:max-w-none mx-auto lg:mx-0 bg-no-repeat bg-contain bg-center bg-[url(./assets/contact-graphic.svg)]"
            aria-hidden
          />
    

          {/* Felipe / Trygve — col 3 on large, middle on mobile */}
          <div className="flex flex-col gap-4 items-start font-trispace text-black self-center">
            <p className="type-h3">
              <LinkButton href="mailto:felipe@avaris.no">@Felipe</LinkButton>
              <span> or </span>
              <LinkButton href="mailto:trygve@avaris.no">@Trygve</LinkButton>
            </p>
            <p className="type-body2">
              If Abbie feels overwhelmed by your curious mind, let humans take over and get in
              back to you straight away.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
